import { combineReducers } from "@reduxjs/toolkit";

import authApi from "store/api/auth";
import filterAPI from "store/api/common";
import blogApi from "store/api/content";
import dividendApi from "store/api/dividend";
import emailTemplatesApi from "store/api/emailTemplates";
import exitWindowApi from "store/api/exitwindow";
import invesmentsApi from "store/api/invesments";
import masterApi from "store/api/master";
import profileApi from "store/api/profile";
import propertyApi from "store/api/property";
import rewardsApi from "store/api/rewards";
import roleApi from "store/api/role";
import saleProceedApi from "store/api/saleProceed";
import settingsApi from "store/api/settings";
import supportApi from "store/api/support";
import transactionsApi from "store/api/transactions";
import userApi from "store/api/users";
import userTokenReducer from "store/reducers/token";
import uiReducer from "store/reducers/ui";

import permissionsReducer from "./permissions";
/** ***************** 
@purpose : root reducer
@Author : INIC
@return : combine reducers
***************** */

export default () =>
  combineReducers({
    ui: uiReducer,
    token: userTokenReducer,
    permissions: permissionsReducer,
    [authApi.reducerPath]: authApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [masterApi.reducerPath]: masterApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [emailTemplatesApi.reducerPath]: emailTemplatesApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [filterAPI.reducerPath]: filterAPI.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [propertyApi.reducerPath]: propertyApi.reducer,
    [transactionsApi.reducerPath]: transactionsApi.reducer,
    [dividendApi.reducerPath]: dividendApi.reducer,
    [rewardsApi.reducerPath]: rewardsApi.reducer,
    [exitWindowApi.reducerPath]: exitWindowApi.reducer,
    [saleProceedApi.reducerPath]: saleProceedApi.reducer,
    [invesmentsApi.reducerPath]: invesmentsApi.reducer,
  });

/** ***************** 
@purpose : RTK Query middlwares
@Author : INIC
@return : array of middlewares
***************** */
export const getReducerMiddlewares = () => [
  authApi.middleware,
  profileApi.middleware,
  settingsApi.middleware,
  userApi.middleware,
  masterApi.middleware,
  roleApi.middleware,
  emailTemplatesApi.middleware,
  blogApi.middleware,
  filterAPI.middleware,
  supportApi.middleware,
  propertyApi.middleware,
  transactionsApi.middleware,
  rewardsApi.middleware,
];
